import { ThemeProvider, useTheme } from '@reckon-web/theme';
import { Flex } from '@reckon-web/flex';
import { makeId } from '@reckon-web/utils';

import { Block } from '../common/block';

import { Logo } from './logo';
import { Nav } from './nav';
import { AddNew } from './add-new';
import { Profile } from './profile';

const HeaderInner = ({ testId = 'header-inner' }) => {
  const theme = useTheme();

  return (
    <Block
      css={{
        display: 'flex',
        flexShrink: 0,
        backgroundColor: theme.palette.background.base,
      }}
    >
      <Flex height={64} alignItems="center" gap="xxlarge">
        <Logo testId={makeId(testId, 'logo')} />
        <Nav testId={makeId(testId, 'nav')} />
        <Flex flexGrow={1} />
        <Flex alignItems="center" gap="large">
          <AddNew testId={makeId(testId, 'add-new')} />
          <Profile testId={makeId(testId, 'profile')} />
        </Flex>
      </Flex>
    </Block>
  );
};

export const Header = ({ testId = 'header' }) => {
  const { palette } = useTheme();

  return (
    <ThemeProvider
      theme={{
        colors: {
          accent: '#3eba63',
          background: '#233365',
          text: '#e9eaf6',
        },
      }}
      paletteResolver={() => ({
        background: {
          dialog: palette.background.dialog,
        },
        menuItem: palette.menuItem,
      })}
      data-testid={testId}
    >
      <HeaderInner />
    </ThemeProvider>
  );
};
